import createMessageTranslation from "./createMessage";
import statesTranslation from "./states";
import boycottTranslation from "./boycott";

const translation = {
  title: {
    ar: (
      <>
        ف<span className="greenText">لسط</span>ين
      </>
    ),
    en: (
      <>
        Pa<span className="greenText">les</span>tine
      </>
    ),
  },
  loading: {
    ar: "...تحميل",
    en: "loading...",
  },
  occupationDurationText: {
    ar: (
      <>
        مرّ على احتلال ف<span className="greenText">لسط</span>ين
      </>
    ),
    en: (
      <>
        Pa<span className="greenText">les</span>tine is occupied from{" "}
      </>
    ),
  },
  createMessageButton: {
    ar: " أنشر رسالتك",
    en: "Share your message",
  },
  messagesButton: {
    ar: "الرسائل",
    en: "Messages",
  },
  departmentsButton: {
    ar: " البلدان",
    en: "Departments",
  },
  years: {
    ar: "سنة",
    en: "years",
  },
  months: {
    ar: "شهر",
    en: "months",
  },
  days: {
    ar: "يوم",
    en: "days",
  },
  messageCardsTitle: {
    ar: "رسائلكم للعالم",
    en: (
      <>
        Your messages <br /> to the world{" "}
      </>
    ),
  },
  boycottButton: {
    ar: "قاطعوا هؤلاء",
    en: "Boycott These",
  },
  ...createMessageTranslation,
  ...statesTranslation,
  ...boycottTranslation,
};

export default translation;
